// Restaurant API URL
// export const RESTAURANT_API_URL = 'http://localhost:8080/api';
 export const RESTAURANT_API_URL = 'https://wazwan-backend-1.onrender.com/api';

// Salon API URL
 export const SALON_API_URL = 'https://husn-billing-server.onrender.com/api';
// export const SALON_API_URL = 'http://localhost:2020/api';

// Default export (restaurant — backward compat)
export const API_URL = RESTAURANT_API_URL;

/**
 * Returns the correct API URL based on business type stored in localStorage.
 * businessType: 'restaurant' | 'salon'
 */
export const getApiUrl = () => {
  const businessType = localStorage.getItem('businessType');
  return businessType === 'salon' ? SALON_API_URL : RESTAURANT_API_URL;
};